export default "__VITE_ASSET__DwVdY$$Z__"